import sizzle from 'sizzle'

export function getEl (selector) {
  const $pageEl = sizzle(selector)
  if ($pageEl.length) {
    return $pageEl[0]
  }
}

export function shouldAttachRight (offsetLeft) {
  const dividingLine = window.innerWidth / 2
  if (offsetLeft < dividingLine) {
    return true
  }
  return false
}

export function getOffset (el) {
  const rect = el.getBoundingClientRect()
  return {
    top: rect.top,
    left: rect.left
  }
}

export function isFixed (elm) {
  var el
  if (typeof elm === 'object') el = elm[0] || elm
  else if (typeof elm === 'string') el = document.querySelector(elm)
  while (typeof el === 'object' && el.nodeName.toLowerCase() !== 'body') {
    if (
      window
        .getComputedStyle(el)
        .getPropertyValue('position')
        .toLowerCase() === 'fixed'
    ) {
      return true
    }
    el = el.parentElement
  }
  return false
}

// OLD!!!
// export function shouldUseParent (el) {
//   const invalidNodes = ['TD', 'TH']
//   if (el && invalidNodes.includes(el.nodeName)) {
//     return el.parentNode
//   }
//   return el
// }

// export function isBody (el) {
//   const bodyPaths = ['HTML', 'BODY']
//   return bodyPaths.includes(el.tagName)
// }

// export function insertEl (newNode, referenceNode) {
//   if (isBody(referenceNode)) {
//     return document.body.append(newNode)
//   }
//   return insertAfter(newNode, referenceNode)
// }

// export function insertAfter (newNode, referenceNode) {
//   referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling)
// }

// export function getZIndex (e) {
//   const z = document.defaultView.getComputedStyle(e).getPropertyValue('z-index')
//   return parseInt(z)
// }

// export function getPosition (el) {
//   return { left: el.offsetLeft, top: el.offsetTop }
// }

// export function addMargin (el, offset) {
//   const style = getComputedStyle(el)
//   if (style.marginLeft) {
//     offset.left = offset.left + parseInt(style.marginLeft)
//   }
//   if (style.marginTop) {
//     offset.top = offset.top + parseInt(style.marginTop)
//   }
//   return offset
// }

// export function addTransforms (parentSelector, position) {
//   const parentEl = sizzle(parentSelector)
//   if (parentEl.length) {
//     const transformPosition = addMargin(parentEl[0], getPosition(parentEl[0]))
//     position.left = position.left - transformPosition.left
//     position.top = position.top - transformPosition.top
//   }
//   return position
// }
